const doc = [({"en":({"js":({"admin":({"agendas":({"live_button":({"the_agenda_was_saved":"The agenda was saved", "show_in_live":"Show in live"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;